'use strict';

class createSwiper {

    constructor(container, breakpoints = {}) {

        this._container = document.querySelector(container);
        this._createSlider(breakpoints);
    }

    _createSlider(breakpoints) {

        let cont = this._container;
        let dataSet = cont.dataset;


        let {

            direction = 'horizontal',
            pager : pagination = null,
            pagerClick : paginationClickable = false,
            next : nextButton = null,
            prev : prevButton = null,
            autoHeight = false,
            centeredSlides = false,
            autoplay = null,
            autoplayDisableOnInteraction = false,
            freeMode = false,
            effect = 'scroll',
            slidesView : slidesPerView = 1,
            spaceBetween = 0,
            crossFade = false,
            passiveListeners = false,

        } = dataSet;

        let swiper = new Swiper(cont, {

            direction: direction,
            pagination: pagination,
            paginationClickable: this._boolean(paginationClickable),
            nextButton: nextButton,
            prevButton: prevButton,
            autoHeight: this._boolean(autoHeight),
            centeredSlides: this._boolean(centeredSlides),
            autoplay: autoplay,
            autoplayDisableOnInteraction: this._boolean(autoplayDisableOnInteraction),
            freeMode: this._boolean(freeMode),
            effect: effect,
            slidesPerView: parseInt(slidesPerView),
            spaceBetween: parseInt(spaceBetween),
            fade: {
                crossFade: this._boolean(crossFade),
            },
            breakpoints: breakpoints,

        });

    }

    _boolean(val = false) {


        switch (typeof(val)) {

            case 'boolean':
                return val;
                break;

            default:
                return val === 'true' ? true : false;
                break;

        }

    }

}

window.createSwiper = createSwiper;
